import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';

export default function QRCodeGenerator() {
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');
  const [logo, setLogo] = useState('');
  const qrRef = useRef(null);

  const downloadQRCode = () => {
    const canvas = qrRef.current.querySelector('canvas');
    const link = document.createElement('a');
    link.download = 'qrcode.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  };

  const handleLogoChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) {
      setLogo('');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      setLogo(event.target.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.heading}>QR Code Generator</h1>

        <input
          type="text"
          placeholder="Enter URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          style={styles.input}
        />

        <input
          type="text"
          placeholder="Title (Optional)"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          style={styles.input}
        />

        <input
          type="file"
          accept="image/*"
          onChange={handleLogoChange}
          style={styles.input}
        />

        {url && (
          <>
            <div style={styles.qrBox}>
              {logo && <img src={logo} alt="Logo" style={styles.logo} />}

              {title && <h3 style={styles.title}>{title}</h3>}

              <div ref={qrRef}>
                <QRCodeCanvas
                  value={url}
                  size={220}
                  level="H"
                  includeMargin
                  imageSettings={
                    logo
                      ? {
                          src: logo,
                          height: 40,
                          width: 40,
                          excavate: true,
                        }
                      : undefined
                  }
                />
              </div>
            </div>

            <button style={styles.button} onClick={downloadQRCode}>
              Download QR Code
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f5f5f5',
  },
  card: {
    background: '#fff',
    padding: 30,
    borderRadius: 12,
    width: 400,
    textAlign: 'center',
  },
  heading: {
    marginBottom: 20,
  },
  input: {
    width: '100%',
    padding: 12,
    marginBottom: 12,
    border: '1px solid #ddd',
    borderRadius: 6,
    boxSizing: 'border-box',
  },
  qrBox: {
    padding: 20,
    border: '1px solid #ddd',
    borderRadius: 10,
    marginTop: 20,
  },
  logo: {
    width: 60,
    height: 60,
    objectFit: 'contain',
    marginBottom: 10,
  },
  title: {
    marginBottom: 15,
  },
  button: {
    marginTop: 20,
    padding: '12px 20px',
    border: 'none',
    background: '#0a7cff',
    color: '#fff',
    borderRadius: 6,
    cursor: 'pointer',
  },
};
